import { get, post, put } from '../utils/axios'

export const getErTypesAPI = async () => {
  return await get('er/types')
}
export const getEmergencyAPI = async (param) => {
  return await get('er', param)
}
export const createErAPI = async (body) => {
  return await post('er', body)
}

export const updateErAPI = async (param, body) => {
  return await put('er', param, body)
}
